import gstinValidityService from "./GstinValidityService";

export const GstinValidityService = {
  checkForValidity: gstinValidityService.checkGstinValid,
  checkGstinRegisterable: gstinValidityService.checkGstinRegisterable
};
